import { render, staticRenderFns } from "./industryEvaluation.vue?vue&type=template&id=3794540d&scoped=true"
import script from "./industryEvaluation.vue?vue&type=script&lang=js"
export * from "./industryEvaluation.vue?vue&type=script&lang=js"
import style0 from "./industryEvaluation.vue?vue&type=style&index=0&id=3794540d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794540d",
  null
  
)

export default component.exports